import React from "react";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

const SectionTablePagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    let start = Math.max(1, currentPage - 1);
    let end = Math.min(totalPages, start + 2);

    if (end - start < 2) {
      start = Math.max(1, end - 2);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  const pages = getPageNumbers();

  const NavButton = ({ onClick, disabled, children }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        w-9 h-9 flex items-center justify-center rounded-lg border transition-all duration-200
        active:scale-95 disabled:opacity-30 disabled:cursor-not-allowed
        ${disabled 
          ? "border-stone-100 bg-transparent text-stone-300" 
          : "border-stone-200 bg-white text-stone-600 hover:border-[#0F172A] hover:text-[#0F172A] hover:bg-stone-50 shadow-sm"
        }
      `}
    >
      {children}
    </button>
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-6 mt-12 px-2 w-full">
      
      {/* KIRI: Total Data */}
      <div className="flex justify-center md:justify-start order-2 md:order-1">
        <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-stone-400">
          Total Results: <span className="text-[#0F172A]">{totalItems}</span>
        </div>
      </div>

      {/* TENGAH: Navigasi Pagination */}
      <div className="flex items-center justify-center gap-1.5 order-1 md:order-2">
        {/* Navigasi Cepat Kiri */}
        <div className="flex items-center gap-1.5 mr-1">
          <NavButton onClick={() => onPageChange(1)} disabled={currentPage === 1}>
            <ChevronsLeft size={14} strokeWidth={2.5} />
          </NavButton>
          <NavButton onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
            <ChevronLeft size={14} strokeWidth={2.5} />
          </NavButton>
        </div>

        {/* Nomor Halaman */}
        <div className="flex items-center gap-1.5 px-3 border-x border-stone-100">
          {pages.map((page) => (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`
                w-9 h-9 rounded-lg text-[10px] font-black transition-all duration-200
                ${currentPage === page
                  ? "bg-[#0F172A] text-white shadow-md shadow-slate-900/20 scale-105 z-10"
                  : "bg-white border border-stone-100 text-stone-500 hover:border-[#0F172A] hover:bg-stone-50"
                }
              `}
            >
              {page}
            </button>
          ))}
        </div>

        {/* Navigasi Cepat Kanan */}
        <div className="flex items-center gap-1.5 ml-1">
          <NavButton onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            <ChevronRight size={14} strokeWidth={2.5} />
          </NavButton>
          <NavButton onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
            <ChevronsRight size={14} strokeWidth={2.5} />
          </NavButton>
        </div>
      </div>

      {/* KANAN: Page Of Info */}
      <div className="flex justify-center md:justify-end order-3">
        <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-stone-400">
          Page <span className="text-[#0F172A] font-black">{currentPage}</span> of {totalPages}
        </div>
      </div>

    </div>
  );
};

export default SectionTablePagination;